<template>
  <div>
    <div id="vue" class="wrap">
      <div class="container">
        <div class="mt-4">
          <h3 class="mr-4 mb-3">
            <i class="fas fa-search mr-2"></i>
            維修查詢
          </h3>
        </div>
        <div class="row mt-2">
          <div class="col-sm-12">
            <div class="card">
              <div class="card-body">
                <div class="row">
                </div>
                <div class="row">
                  <div class="col-sm-6">
                    <div class="form-group form-group-lg">
                      <label for="light-id" class="">路燈編號</label>
                      <input type="text" class="form-control" placeholder="請填入7位數字"  v-model="streetlight_no">
                    </div>
                  </div>
                  <div class="col-12"><hr></div>
                  <div class="col-12">
                    <h5>地址 / 位置</h5>
                  </div>
                  <div class="col-sm-3">
                    <div class="form-group">
                      <label for="district" class="">行政區</label>
                      <select @change="update_select" name="district" id="district" class="form-control selectpicker" title="請選擇" v-model="district_id">
                        <option v-for="d in district_list" :key="d.id" :value="d.id">{{d.name}}</option>
                      </select>
                    </div>
                  </div>
                  <div class="col-sm-3">
                    <div class="form-group">
                      <label for="village" class="">里</label>
                      <select name="village" id="village" class="form-control selectpicker" title="請選擇" v-model="village_id">
                        <option v-for="v in village_list" :key="v.id" :value="v.id">{{v.name}}</option>
                      </select>
                    </div>
                  </div>
                  <div class="col-sm-6">
                    <div class="form-group">
                      <label for="" class="">詳細位置</label>
                      <input type="text" class="form-control"  v-model="address">
                    </div>
                  </div>
                  <div class="col-12"><hr></div>
                  <div class="col-sm-6">
                    <date-rangepicker-component ref="dpicker" label="報修日期" autocomplete="off" ></date-rangepicker-component>
                    <!-- <div class="form-group">
                      <label>報修日期</label>
                      <input type="date" class="form-control">
                    </div> -->
                  </div>
                  <div class="col-sm-6">
                    <div class="form-group">
                      <label>報修人電話</label>
                      <input type="phone" class="form-control" v-model="citizen_phone">
                    </div>
                  </div>
                </div>

                <hr class="border-secondary">
                <div class="d-flex justify-content-center">
                  <button style="width: 150px;" class="btn btn-outline-info" @click="search">搜尋</button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="row" v-if="result">
          <div class="col-sm-12">
            <div class="card">
              <div class="card-body">
                <h4>查詢結果</h4>

                <div class="table-responsive">
                    <table id="table" class="table border table-lg table-striped dt-responsive nowrap p-0" cellspacing="0" width="100%">
                      <thead>
                        <tr>
                          <th>案件編號</th>
                          <th>狀態</th>
                          <th>路燈編號</th>
                          <th>路燈位置</th>
                          <th>報修日期</th>
                        </tr>
                      </thead>
                    </table>
                  </div>
                

              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { api } from "../../../apis/main.js"
import { Toast } from '../../../assets/helpers.js';
import DateRangepickerComponent from './DateRangepickerComponent.vue';
import dlang from '../dlang.json'
let $ = window.$;
export default {
  name: 'SearchPage',
  props: {
  },
  components: {
    DateRangepickerComponent
  },
  data() {
    return {
      streetlight_no: "",
      district_id: "",
      village_id: "",
      address: "",
      start_date: "",
      end_date: "",
      citizen_phone: "",
      region_list: [],
      result: [],
      dateRange:'',
    }
  },
  computed: {
    district_list() {
      if(this.region_list.length == 0) return [];
      return this.region_list.map(ele=>{
        return {
          id: ele.id,
          name: ele.name
        }
      })
    },
    village_list() {
      let d_id = this.district_id;
      if (d_id == '') return [];
      let res = this.region_list.filter(ele => {
        return ele.id == d_id;
      })[0].village_list;
       res.unshift({
        id: '',
        name: ''
      });
      return res;
    }
  },
  mounted() {
    $('#table').DataTable({
      responsive: true,
      language:  dlang,
      searching: false,
      processing: true,
      paging: false,
      lengthChange: false,
      dom: "<'table-responsive'tr>" +
            "<'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7'p>>",
      order: [],
      columnDefs: [
        { className: 'text-center', targets: [-1] },
        { orderable: false, targets: '_all'},
      ],
    });
    $('.selectpicker').selectpicker({
      container:'body',
      size: 6,
      dropupAuto: false
    });
    this.getRegion().then(res=>{
      this.region_list = res.data
      this.region_list.unshift({
        id: '',
        name: ''
      });
      this.$nextTick(()=>{
        $('.selectpicker').selectpicker('refresh')
      })
    });
  },
  created() {
  },
  methods: {
    onSearch: function(){
      const {start, end} = this.dateRange;
      console.log('開始日期',start);
      console.log('結束日期',end);
    },
    async getRegion() {
      let res = await api.get("get_district_village_option");
      return res;
    },
    async search() {
      let drange = this.$refs.dpicker.val || "~";
      let start = drange.split('~')[0].trim(), end = drange.split('~')[1].trim();
      let data = {
        streetlight_no: this.streetlight_no,
        district_id: this.district_id,
        village_id: this.village_id,
        address: this.address,
        start_date: start,
        end_date: end,
        citizen_phone: this.citizen_phone
      };
      for(let i of Object.keys(data)) {
        if(data[i] == '') {
          delete data[i];
        }
      }
      let formdata = new FormData();
      for(let key of Object.keys(data)) {
        formdata.append(key, data[key]);
      }
      let result = await api.post("query_repair_case", formdata,{ 
        headers: { 'Content-Type': 'multipart/form-data' },
        // withCredentials: true
      }).catch(e => {
        if(e.response.status == 400) {
          Toast({
            icon:'error',
            heading: '查詢失敗',
            text: "須至少輸入一個條件"
          });
          return;
        }
      })
      if(result !== undefined) {
        this.result = result.data;
      }
      this.$nextTick(()=>{
        $('#table').DataTable().destroy()
        $('#table').DataTable({
          responsive: true,
          language:  dlang,
          searching: false,
          processing: true,
          paging: false,
          lengthChange: false,
          dom: "<'table-responsive'tr>" +
                "<'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7'p>>",
          order: [],
          columnDefs: [
            { className: 'text-center', targets: [-1] },
            { orderable: false, targets: '_all'},
          ],
          data: this.result.map(e => {
            return [e.repair_case_no, e.repair_case_status, e.streetlight_no, e.address, e.repair_case_create_date.replace('T', ' ')]
          })
        });

      })
    }
  },
  watch: {
    district_id: function() {
      this.$nextTick(()=>{
        $('.selectpicker').selectpicker('refresh')
      })
    }
  }
}
</script>

<style scoped>
</style>
